const STORAGE_KEY = 'tr-newsletter-prompt-hidden-until'
const ONE_DAY_MS = 24 * 60 * 60 * 1000

/**
 * TR-40866: click outside the newsletter prompt hides it for one day
 * (not a permanent "Jetzt nicht"). Survives the tab; other devices still see it.
 */
export function useNewsletterPromptSnooze () {
  function isSnoozed (): boolean {
    if (!import.meta.client) {
      return false
    }
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return false
    }
    const until = Number(raw)
    if (!Number.isFinite(until) || until <= Date.now()) {
      localStorage.removeItem(STORAGE_KEY)
      return false
    }
    return true
  }

  function snoozeForOneDay (): void {
    if (!import.meta.client) {
      return
    }
    localStorage.setItem(STORAGE_KEY, String(Date.now() + ONE_DAY_MS))
  }

  return { isSnoozed, snoozeForOneDay }
}
